// ============================================
// WISHLIST APP — Main Script
// ============================================

(function () {
  'use strict';

  const APP_URL = window.WISHLIST_CONFIG?.appUrl || '';
  const CUSTOMER_EMAIL = window.WISHLIST_CONFIG?.customerEmail;
  const CUSTOMER_NAME = window.WISHLIST_CONFIG?.customerName;

  // ── Token Management ──────────────────────
  function getToken() {
    return localStorage.getItem('wishlist_token');
  }

  function setToken(token) {
    localStorage.setItem('wishlist_token', token);
  }


  // ── API Calls ─────────────────────────────
  async function apiCall(endpoint, method = 'GET', body = null) {
    const token = getToken();
    const options = {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': 'Bearer ' + token })
      }
    };
    if (body) options.body = JSON.stringify(body);

    const res = await fetch(APP_URL + endpoint, options);
    return res.json();
  }

  // ── Load Wishlist Count ───────────────────
  async function loadCount() {
    if (!getToken()) return;
    try {
      const data = await apiCall('/api/wishlist');
      const countEl = document.getElementById('wl-count');
      if (countEl && data.count !== undefined) {
        countEl.textContent = data.count;
      }
    } catch (e) {}
  }

  // ── Auto Login Shopify Customer ───────────
  async function autoLoginCustomer() {
    if (!CUSTOMER_EMAIL || getToken()) return;

    try {
      const data = await apiCall('/api/auth/guest-register', 'POST', {
        email: CUSTOMER_EMAIL,
        name: CUSTOMER_NAME || ''
      });
      if (data.token) {
        setToken(data.token);
        loadCount();
      }
    } catch (e) {}
  }

  // ── Wishlist Heart Buttons ────────────────
  function initHeartButtons() {
    const buttons = document.querySelectorAll('[data-wishlist-btn]');
    buttons.forEach(btn => {
      checkIfWishlisted(btn);
      btn.addEventListener('click', handleHeartClick);
    });
  }

  async function checkIfWishlisted(btn) {
    if (!getToken()) return;
    try {
      const data = await apiCall('/api/wishlist');
      if (data.items) {
        const productId = btn.dataset.productId;
        const found = data.items.find(i => i.product_id === productId);
        if (found) {
          btn.textContent = '❤️';
          btn.dataset.wishlisted = 'true';
        }
      }
    } catch (e) {}
  }

  async function handleHeartClick(e) {
    const btn = e.currentTarget;
    const token = getToken();

    if (!token) {
      showGuestPopup(btn);
      return;
    }

    const productData = {
      productId: btn.dataset.productId,
      title: btn.dataset.title,
      image: btn.dataset.image,
      price: parseFloat(btn.dataset.price.replace(/,/g, '')) || 0,
      url: btn.dataset.url || window.location.href,
      variantId: btn.dataset.variantId || ''
    };

    if (btn.dataset.wishlisted === 'true') {
      // Remove from wishlist
      await apiCall('/api/wishlist', 'DELETE', { productId: productData.productId });
      btn.textContent = '🤍';
      btn.dataset.wishlisted = 'false';
      updateCount(-1);
    } else {
      // Add to wishlist
      const res = await apiCall('/api/wishlist', 'POST', productData);
      if (res.success || res.wishlisted) {
        btn.textContent = '❤️';
        btn.dataset.wishlisted = 'true';
        updateCount(1);
      }
    }
  }

  function updateCount(delta) {
    const countEl = document.getElementById('wl-count');
    if (countEl) {
      const current = parseInt(countEl.textContent) || 0;
      countEl.textContent = Math.max(0, current + delta);
    }
  }

  // ── Guest Popup ───────────────────────────
  let pendingBtn = null;

  function showGuestPopup(btn) {
    pendingBtn = btn;

    const existing = document.getElementById('wl-popup-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'wl-popup-overlay';
    overlay.innerHTML = `
      <div style="
        position:fixed;top:0;left:0;right:0;bottom:0;
        background:rgba(0,0,0,0.55);z-index:999999;
        display:flex;align-items:center;justify-content:center;
        padding:20px;
      ">
        <div style="
          background:#fff;border-radius:16px;padding:35px 30px;
          max-width:420px;width:100%;text-align:center;
          box-shadow:0 20px 60px rgba(0,0,0,0.2);
        ">
          <div style="font-size:40px;margin-bottom:10px">❤️</div>
          <h3 style="margin:0 0 8px;font-size:22px;color:#1a1a1a">
            Save to Wishlist
          </h3>
          <p style="margin:0 0 25px;color:#666;font-size:14px">
            Enter your email to save this item and get reminders
          </p>

          <input id="wl-email-input" type="email" 
            placeholder="your@email.com" 
            style="
              width:100%;padding:12px 15px;border:1.5px solid #ddd;
              border-radius:8px;font-size:15px;
              box-sizing:border-box;margin-bottom:10px;
              outline:none;transition:border 0.2s;
            "
            onfocus="this.style.borderColor='#e74c3c'"
            onblur="this.style.borderColor='#ddd'"
          >

          <input id="wl-name-input" type="text" 
            placeholder="Your name (optional)" 
            style="
              width:100%;padding:12px 15px;border:1.5px solid #ddd;
              border-radius:8px;font-size:15px;
              box-sizing:border-box;margin-bottom:20px;
              outline:none;transition:border 0.2s;
            "
            onfocus="this.style.borderColor='#e74c3c'"
            onblur="this.style.borderColor='#ddd'"
          >

          <button id="wl-submit-btn" style="
            width:100%;padding:13px;background:#e74c3c;
            color:white;border:none;border-radius:8px;
            font-size:16px;font-weight:600;cursor:pointer;
            margin-bottom:12px;transition:background 0.2s;
          "
          onmouseover="this.style.background='#c0392b'"
          onmouseout="this.style.background='#e74c3c'"
          >
            Save to Wishlist ❤️
          </button>

          <button id="wl-close-btn" style="
            background:none;border:none;color:#999;
            font-size:14px;cursor:pointer;padding:5px;
          ">
            Cancel
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    // Close button
    document.getElementById('wl-close-btn').onclick = () => overlay.remove();
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay.firstElementChild) overlay.remove();
    });

    // Submit
    document.getElementById('wl-submit-btn').onclick = handleGuestSubmit;

    // Enter key
    document.getElementById('wl-email-input').onkeypress = (e) => {
      if (e.key === 'Enter') handleGuestSubmit();
    };
  }

  async function handleGuestSubmit() {
    const emailInput = document.getElementById('wl-email-input');
    const nameInput = document.getElementById('wl-name-input');
    const submitBtn = document.getElementById('wl-submit-btn');

    const email = emailInput.value.trim();
    const name = nameInput.value.trim();

    // Validate email
    if (!email || !email.includes('@')) {
      emailInput.style.borderColor = '#e74c3c';
      emailInput.placeholder = 'Please enter a valid email';
      return;
    }

    submitBtn.textContent = 'Saving...';
    submitBtn.disabled = true;

    try {
      const data = await apiCall('/api/auth/guest-register', 'POST', { email, name });

      if (data.token) {
        setToken(data.token);
        document.getElementById('wl-popup-overlay')?.remove();

        // Now add to wishlist
        if (pendingBtn) {
          await handleHeartClick({ currentTarget: pendingBtn });
          pendingBtn = null;
        }

        loadCount();
      } else {
        submitBtn.textContent = 'Try Again';
        submitBtn.disabled = false;
      }
    } catch (err) {
      submitBtn.textContent = 'Error — Try Again';
      submitBtn.disabled = false;
    }
  }

  // ── INIT ──────────────────────────────────
  function init() {
    autoLoginCustomer();
    loadCount();
    initHeartButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();